import { render, staticRenderFns } from "./merge-client-profile-modal.vue?vue&type=template&id=4b79579d"
import script from "./merge-client-profile-modal.vue?vue&type=script&lang=js"
export * from "./merge-client-profile-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports